import Api from '../shared/Api';
import { Promise } from 'es6-promise';

class LogsApi {
    static getLogs(id?: number, type?: string, page?: number, pageSize?: number): any {
        let url = '/logs';
        if (id) {
            url += `?${type}=${id}`;
        }
        if (page) {
            url += (url.lastIndexOf('?') >= 0 ? '&' : '?') + `page=${page}`;
        }
        if (pageSize) {
            url += (url.lastIndexOf('?') >= 0 ? '&' : '?') + `pageSize=${pageSize}`;
        }
        return new Promise<any>((resolve: any, reject: any) => {
            new Api()
                .get(url)
                .then(resolve)
                .catch((error: any) => {
                    reject(error);
                });
        });
    }
}

export default LogsApi;
